import React from 'react';
import { Link } from 'react-router-dom';
import { Col } from 'reactstrap';

const ProjectThumbnail = ({ title, images, subtitle, slug }) => (
  <Col xs="12" lg="4" className="project-item">
    <Link to={`/project/${slug}`}>
      <span className="project-item__caption">
        <span className="project-item__caption-content">
          {title}
          <p>{subtitle}</p>
        </span>
      </span>
      <img className="img-fluid" src={images.thumbnail} alt="BoomApp" />
    </Link>
  </Col>
);

export default ProjectThumbnail;



// WEBPACK FOOTER //
// ./src/components/Projects/ProjectThumbnail/ProjectThumbnail.js